export const apiDeliveryUnits = {
	fetchGroupDeliveryByDate: async (date: string): Promise<IGroupDeliveryModel[]> => {
		const response = await apiCommon<IGroupDelivery[]>(`api/employee/get-delivery-orders?dates[]=${date}`, {
			method: 'GET',
		})

		const raw = normalizeGroupDeliveriesResponse(response)
		return raw.length ? GroupDeliveries(raw) : []
	},

	exportGroupDeliveryExcel: async (date: string): Promise<IGroupDeliveryExcel> => {
		const { data } = await apiCommon<IGroupDeliveryExcel>('api/employee/logistic-units/download', {
			method: 'POST',
			isFileDownload: true,
			body: {
				date,
				type: 'xlsx',
				external_module_type: 'group_delivery',
				external_module: 'crm',
			},
		})

		return data
	},
}
